module.exports = __webpack_public_path__ + "img/YouAbsolutePiece.579becfb.png";